import React, { useState } from "react";
import axios from "axios";
import { message } from "antd";
import { useNavigate } from "react-router-dom";

const Login = ({setUser}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({}); // Hata mesajlarını saklar
  const apiUrl = process.env.REACT_APP_MONGO_URL;
  const navigate = useNavigate(); // Yönlendirme için

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   // Hata kontrolü
  //   const newErrors = {};
  //   if (!email) newErrors.email = "Bu alan boş bırakılamaz!";
  //   if (!password) newErrors.password = "Bu alan boş bırakılamaz!";

  //   // Hata varsa, göster
  //   if (Object.keys(newErrors).length > 0) {
  //     setErrors(newErrors);
  //     return;
  //   }

  //   // Hatalar temizlenir
  //   setErrors({});
  //   console.log("Form gönderildi:", { email, password });
  //   // Backend'e API çağrısı yapılabilir
  // };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(`${apiUrl}/api/auth/login`, {
        email,
        password,
      });

      message.success("giriş başarılı")
      localStorage.setItem("token", data.accessToken); // Token'ı sakla
      setUser(data); // Kullanıcıyı state'e kaydet
      navigate("/"); // Başarılı girişten sonra yönlendir
    } catch (err) {
      message.error("giriş başarısız")
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      {/* {errors && <p style={{ color: "red" }}>{errors}</p>} */}
      {/* Kart */}
      <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src="/logo.jpg"
            alt="Logo"
            className="h-16"
          />
        </div>
        {/* Başlık */}
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">
          Giriş Yap
        </h2>

        {/* Form */}
        <form onSubmit={handleLogin}>
          {/* Email Alanı */}
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)} // Email state güncellemesi
              className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none ${
                errors.email ? "border-red-500" : "border-gray-300"
              }`}
              placeholder="E-posta adresinizi girin"
            />
            {/* Hata Mesajı */}
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">{errors.email}</p>
            )}
          </div>

          {/* Şifre Alanı */}
          <div className="mb-6">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Şifre
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)} // Şifre state güncellemesi
              className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none ${
                errors.password ? "border-red-500" : "border-gray-300"
              }`}
              placeholder="Şifrenizi girin"
            />
            {/* Hata Mesajı */}
            {errors.password && (
              <p className="text-red-500 text-sm mt-1">{errors.password}</p>
            )}
          </div>

          {/* Giriş Yap Butonu */}
          <button
            type="submit"
            className="w-full bg-gray-800 hover:bg-gray-900 text-white font-medium py-2 px-4 rounded-lg focus:ring-2 focus:ring-gray-500 focus:outline-none"
          >
            Giriş Yap
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
